<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
    <div v-loading="items.meta.loading">
        <div class="header-with-line">
            <img src="/images/dashboard/newsletter.svg" />
            <h2>Newsletter</h2>
            <div class="line"></div>
        </div>
        <el-table
            class="mt-20 el-table--no-border el-table--no-header"
            :data="tableData"
        >
            <el-table-column label="Community">
                <template v-slot="{ row }">
                    {{ current_community.newsletter_name }}
                </template>
            </el-table-column>
            <el-table-column prop="issue" label="Issue"></el-table-column>
            <el-table-column prop="actions">
                <template v-slot="{ row }">
                    <el-button-group>
                        <el-button
                            type="info"
                            round
                            v-if="current_community.suspended"
                            >Suspended</el-button
                        >
                        <el-button
                            round
                            class="el-button--corwin-green"
                            style="width: 185px"
                            @click="editItem(row.newsletter)"
                            v-else
                        >
                            {{ row.button_text }}
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            title="Create Newsletter"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="400px"
        >
            <el-form>
                <el-form-item required label="Year/Month">
                    <el-input
                        :value="currentMonth.format('MMMM YYYY')"
                        readonly
                    />
                </el-form-item>
                <el-button icon="el-icon-arrow-right" @click="skipMonth()"
                    >Skip {{ currentMonth.format("MMMM YYYY") }}
                </el-button>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button
                    type="primary"
                    @click="submit()"
                    :loading="form.busy"
                    icon="mdi mdi-content-save"
                    >Create
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as Routes from "@/constants/routes";
import * as Actions from "@/store/constants/actions";
import * as Getters from "@/store/constants/getters";
import * as CalendarStatus from "@/constants/calendar-statuses";

export default {
    data() {
        return {
            items: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false,
                },
            },
            dialogVisible: false,
            form: new Form({
                year: null,
                month: null,
            }),
        };
    },
    computed: {
        ...mapState(["current_community"]),
        ...mapGetters([Getters.CURRENT_MONTH, Getters.NEWSLETTER_AVAILABLE]),
        tableData() {
            let newsletter = _.find(this.items.data, {
                year: this[Getters.CURRENT_MONTH].year(),
                month: this[Getters.CURRENT_MONTH].month() + 1,
            });
            let button_text;
            switch (_.get(newsletter, "status")) {
                case CalendarStatus.IN_PROGRESS:
                    button_text = "Continue Working";
                    break;
                case CalendarStatus.IN_SHOPPING_CART:
                    button_text = "In Shopping Cart";
                    break;
                case CalendarStatus.READY_TO_BEGIN:
                default:
                    button_text = "Get Started";
                    break;
            }
            return [
                {
                    newsletter,
                    issue:
                        this[Getters.CURRENT_MONTH].format("MMMM YYYY") +
                        " Issue",
                    status: newsletter
                        ? newsletter.formatted_status
                        : "Ready to Begin",
                    button_text,
                },
            ];
        },
    },
    mounted() {
        this.initSkipForm();
        this.getData();
    },
    methods: {
        getData() {
            this.items.meta.loading = true;
            axios
                .get(`/web-api/newsletter`)
                .then((response) => {
                    this.setData(response);
                })
                .finally(() => (this.items.meta.loading = false));
        },
        initSkipForm() {
            this.form.year = this.currentMonth.year();
            this.form.month = this.currentMonth.month() + 1;
        },
        setData(response) {
            this.items.data = response.data.data;
            this.items.meta.pagination = response.data.meta.pagination;
        },
        editItem(item) {
            if (item) {
                this.$router.push({
                    name: Routes.EDIT_NEWSLETTER,
                    params: {
                        id: item.id,
                    },
                });
            } else {
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.submit().finally(() => {
                    loading.close();
                });
            }
        },
        create() {
            this.dialogVisible = true;
        },
        submit() {
            return window.App.post(`/web-api/newsletter`, this.form).then(
                (response) => {
                    this.$router.push({
                        name: Routes.EDIT_NEWSLETTER,
                        params: {
                            id: response.data.id,
                        },
                    });
                },
            );
        },
        skipMonth() {
            this.$confirm(
                `Are you sure you want to skip ${this.currentMonth.format(
                    "MMMM",
                )}?`,
                "Confirmation",
                {
                    confirmButtonText: "Yes",
                    confirmButtonClass: "el-button--warning",
                    cancelButtonText: "Cancel",
                    type: "warning",
                },
            )
                .then(() => {
                    this.$store.dispatch(Actions.SKIP_MONTH).then(() => {
                        this.$notify.success({
                            message: `Newsletter has been skipped to ${this.currentMonth.format(
                                "MMMM",
                            )} ${this.currentMonth.year()}.`,
                        });
                        this.initSkipForm();
                    });
                })
                .catch(() => {
                    //user cancelled
                });
        },
    },
};
</script>

<style scoped></style>
